import React, { useState } from 'react';
import { ArrowRight, CheckCircle2, Loader2, Mail } from 'lucide-react';
import { useToast } from '../../hooks/use-toast';
import { subscribeNewsletter, readableError } from '../../lib/api';

const Newsletter = () => {
  const { toast } = useToast();
  const [email, setEmail] = useState('');
  const [state, setState] = useState('idle'); // idle | loading | done

  const onSubmit = async (e) => {
    e.preventDefault();
    if (!email) return;
    try {
      setState('loading');
      await subscribeNewsletter(email);
      setState('done');
      toast({ title: "You're in.", description: 'Watch your inbox for our next update.' });
    } catch (err) {
      setState('idle');
      toast({ title: 'Please try again', description: readableError(err) });
    }
  };

  return (
    <section className="py-20 lg:py-28">
      <div className="mx-auto max-w-7xl px-6 lg:px-10">
        <div className="rounded-[32px] p-8 lg:p-14 border border-[rgba(31,58,46,0.1)] bg-[var(--brand-cream-2)] grid lg:grid-cols-12 gap-8 items-center">
          <div className="lg:col-span-7 reveal">
            <div className="h-11 w-11 rounded-full grid place-items-center bg-[var(--brand-green)] text-[var(--brand-cream)] mb-5">
              <Mail size={18} strokeWidth={1.6} />
            </div>
            <div className="text-xs uppercase tracking-[0.24em] text-[var(--brand-gold)] mb-3">Health insights, monthly</div>
            <h2 className="font-serif text-3xl lg:text-5xl text-green tracking-tight leading-[1.05]">
              Proactive wellness, <em className="italic">delivered</em> to your inbox.
            </h2>
            <p className="mt-4 text-[var(--brand-mute)] max-w-lg">
              Curated by our clinicians. Practical, evidence-based tips on metabolic health, hormones, nutrition and longevity. No spam — unsubscribe any time.
            </p>
          </div>
          <div className="lg:col-span-5">
            {state === 'done' ? (
              <div className="reveal p-6 rounded-2xl bg-[var(--brand-green)] text-[var(--brand-cream)] flex items-center gap-3">
                <div className="h-10 w-10 rounded-full bg-[var(--brand-gold)] text-[var(--brand-green)] grid place-items-center shrink-0">
                  <CheckCircle2 size={20} />
                </div>
                <div>
                  <div className="font-serif text-lg">You’re subscribed.</div>
                  <div className="text-sm opacity-85">We’ll be in touch soon.</div>
                </div>
              </div>
            ) : (
              <form onSubmit={onSubmit} className="reveal flex items-stretch gap-2 p-2 rounded-2xl bg-[var(--brand-cream)] border border-[rgba(31,58,46,0.15)]">
                <input
                  type="email"
                  required
                  placeholder="your@email.com"
                  value={email}
                  onChange={(e) => setEmail(e.target.value)}
                  className="flex-1 bg-transparent px-4 py-3 text-green placeholder:text-[var(--brand-mute)] focus:outline-none"
                />
                <button type="submit" disabled={state === 'loading'} className="btn-primary text-sm disabled:opacity-70">
                  {state === 'loading' ? <Loader2 size={16} className="animate-spin" /> : (<>Subscribe <ArrowRight size={16} /></>)}
                </button>
              </form>
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Newsletter;
